import { useRef } from 'react';
import type { BlockStateUnionType } from '@unifyapps/defs/types/block';
import { useMountEffect, useUnmountEffect } from '@react-hookz/web';
import { useRegistryContext } from '../components/RegistryProvider';
import { useGlobalStateStore } from '../stores/GlobalStateStore';

export function useSetBlockRef({ blockState }: { blockState?: BlockStateUnionType }) {
  const ref = useRef(undefined);
  const { registry } = useRegistryContext();
  const componentType = blockState?.componentType;
  const useBlockRef = registry.getUseBlockRef(componentType);
  const blockId = blockState?.id;

  const { setBlockRef, removeBlockRef } = useGlobalStateStore().use.actions();

  useMountEffect(() => {
    if (!useBlockRef) return;
    if (blockId) {
      setBlockRef(blockId, ref);
    }
  });

  useUnmountEffect(() => {
    if (!useBlockRef) return;
    if (blockId) {
      removeBlockRef(blockId);
    }
  });

  return {
    blockRef: ref,
  };
}
